import React from 'react';
import { Link } from 'react-router-dom';

/**
 * لینک داخلی با پشتیبانی از باز شدن در تب جدید (Ctrl/Cmd+Click یا کلیک وسط).
 */
const NavMenuLink = ({ to, children, className = '', onNavigate, title }) => {
  if (!to) return children;

  return (
    <Link
      to={to}
      title={title}
      className={[
        'block w-full text-inherit no-underline hover:text-inherit focus:text-inherit',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
        onNavigate?.();
      }}
    >
      {children}
    </Link>
  );
};

export default NavMenuLink;
